import { AxiosInstance } from 'axios'
import {
    AutocompleteResult,
    KeywordHistoriesResponse,
    SearchDocument,
    SearchHistoryItem,
    SearchParams,
    SearchResults,
} from './search.type'

export class GlobalSearchApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Perform global search
     */
    async search(params: SearchParams): Promise<SearchResults> {
        const { q, ...filters } = params
        const response = await this.client.get<SearchResults>('/search', {
            params: {
                q,
                ...filters,
            },
        })
        return response.data
    }

    /**
     * Load more search results
     */
    async loadMore(params: SearchParams): Promise<SearchResults> {
        const { q, ...filters } = params
        const response = await this.client.get<SearchResults>('/search/load-more', {
            params: {
                q,
                ...filters,
            },
        })
        return response.data
    }

    /**
     * Get autocomplete suggestions
     */
    async autocomplete(keyword: string): Promise<AutocompleteResult> {
        const response = await this.client.get<AutocompleteResult>('/search/autocomplete', {
            params: { q: keyword },
        })
        return response.data
    }

    /**
     * Get keyword search histories
     */
    async keywordHistories(): Promise<KeywordHistoriesResponse> {
        const response = await this.client.get<KeywordHistoriesResponse>('/search/keyword-histories')
        return response.data
    }

    /**
     * Get full search histories (saved queries)
     */
    async histories(): Promise<SearchDocument[]> {
        const response = await this.client.get<SearchDocument[]>('/search/histories')
        return response.data
    }

    /**
     * Save a search history item
     */
    async saveHistory(data: SearchHistoryItem): Promise<void> {
        await this.client.post('/search/histories', data)
    }
}
